module.exports = __webpack_public_path__ + "img/Open_bg.31467bed.png";